<footer class="footer text-center py-2">
    © 2025 White Label. All rights reserved.
</footer>
